var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"app-sidebar"},[_c('div',{staticClass:"app-sidebar__logo"},[_c('router-link',{staticClass:"header-brand",attrs:{"to":"/admin"}},[_c('h2',{staticStyle:{"color":"white","font-size":"20px"}},[_vm._v("پنل مدیریت ناهید ترابی")])])],1),_c('div',{staticClass:"app-sidebar3"},[_c('Menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }